/**
 * I4 ("Load earlier messages", 2026-07-15) — affordance copy (EN/ES).
 *
 * Leaf module (no React, no component imports) so the copy contract is
 * pinnable from tests without loading the whole GlobalChatSystem tree.
 */
export const LOAD_EARLIER_MESSAGES_COPY: Record<'en' | 'es', { idle: string; loading: string }> = {
  en: { idle: 'Load earlier messages', loading: 'Loading earlier messages…' },
  es: { idle: 'Cargar mensajes anteriores', loading: 'Cargando mensajes anteriores…' },
};

/** Resolve the copy pair for a UI language (unknown → EN). */
export function loadEarlierMessagesCopy(language: string): { idle: string; loading: string } {
  return LOAD_EARLIER_MESSAGES_COPY[language === 'es' ? 'es' : 'en'];
}
